enum DateTemplate {
  DateTimeWithTimezone = 'dddd, MMMM D [at] h:mm a z',
  MMDDYYYY = 'MM/DD/YYYY',
  MonthDayYear = 'MMMM D, YYYY',
}

export { DateTemplate };
